import React, {createRef, useState, useEffect} from 'react';
import moment from "moment";
import __ from "lodash";
import { Grid} from "@material-ui/core";

import { DatePicker, FormDialog, MaskedTime }from "../../../../controls";
import Validator from "../../validators/EditTripLegStdValidator";


const EditTripLegStdDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const SystemData = props.systemData;
  const apiSitePrefix = props.apiSitePrefix;
  const handleUpdateEvent = props.handleUpdateEvent;
  const formatChars = props.formatChars;
  const classes = props.classes;

  const requestRef = createRef(0);
  const eventBus = SystemData.eventBus;

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {},
    title: 'Edit Scheduled Departure Time'
  });

  useEffect(()=> {
    const open = async (record) => {
      setDialogStates({...dialogStates, showDialog:true, record, title: `Edit Scheduled Departure Time for ${record.airlineCode}${record.flightNo}`});
    }

    eventBus.bind("EditTripLegStdDialog.open", open);

    return () => {
      eventBus.unbind("EditTripLegStdDialog.open", open);
    }
  }, [dialogStates, eventBus]);


  const tomorrow = moment.utc().add(1, 'day');
  const minDate = moment.utc().startOf('month').subtract(7, 'days');
  const maxDate = moment(minDate).add(3, 'year');
  const initialDate = tomorrow.toISOString();
  const dateFormat = "DD/MM/YYYY";

  if (dialogStates.showDialog) {
    return (
      <FormDialog
        formId="editTripLegStd"
        title={dialogStates.title}
        message=""
        open={dialogStates.showDialog}
        record={dialogStates.record}
        dialogOptions={{maxWidth: "sm", fullWidth: false}}
        classes={classes}
        validator={Validator}
        buttons = {{
          save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{
            if (status.buttonState && status.buttonState.disabled) return true;
            return status.error;
          }},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            eventBus.trigger(handleUpdateEvent, record);
            setDialogStates({...dialogStates, showDialog:false, record: null, title: `Edit Scheduled Departure Time`});
            if (typeof props.onClose === 'function') {props.onClose()}
          } else {
            setDialogStates({...dialogStates, showDialog: false, record: null, title: `Edit Scheduled Departure Time`});
            if (typeof props.onClose === 'function') {props.onClose()}
          }
        }}

      >
        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={12} checkChildren={true}>
          {(record, changeRecord) => (
            <div>
              <div style={{display: "inline-block", padding: 2, position: "relative"}}>STD:</div>
              <div style={{display: "inline-block", padding: 2, position: "relative", top: 5}} checkChildren={true}>
                <DatePicker
                  id="scheduledDepartureTimeUtc"
                  style={{width: "100%"}}
                  minDate={minDate}
                  maxDate={maxDate}
                  defaultValue={initialDate}
                  disableToolbar={true}
                  autoOk={true}
                  format={dateFormat}
                  onChange={(value, props) => {
                    const {record, recordChange} = props;
                    const newTripDate = moment(value).startOf('day');
                    if (!newTripDate.isValid()) return;
                    const diffDays = newTripDate.diff(moment(record.scheduledDepartureTimeUtc).startOf('day'), 'days');
                    const std = moment(record.scheduledDepartureTimeUtc).add(diffDays, 'days').toISOString();
                    const sta = moment(record.scheduledArrivalTimeUtc).add(diffDays, 'days').toISOString();
                    recordChange({
                      scheduledDepartureTimeUtc: std,
                      scheduledArrivalTimeUtc: sta,
                      changed: true
                    });
                  }}
                />
              </div>

              <div style={{display: "inline-block", padding: 2, position: "relative", top: -2}} checkChildren={true}>
                {(record, changeRecord) => (
                  <MaskedTime
                    id="scheduledDepartureTimeUtc"
                    source="timestamp"
                    onChange={(value)=>{
                      if (!value) return;
                      if (typeof value !== 'string' || value.indexOf(':') < 1 || value.split(':').length !== 2) return;
                      value = value.replace(/\s/g, '0');
                      const [hours,  minutes] =  value.split(':');
                      if (isNaN(hours) || hours < 0 || hours > 23) return;
                      if (isNaN(minutes) || minutes < 0 || hours > 59) return;

                      let std = record.scheduledDepartureTimeUtc;
                      const newStd = moment.utc(std).startOf('day')
                                                                .add(hours, 'hour')
                                                                .add(minutes, 'minute')
                                                                .toISOString();
                      const diffMins = moment.utc(newStd).diff(moment(std).startOf('minute'), 'minute');
                      const sta = moment(record.scheduledArrivalTimeUtc).add(diffMins, 'minute').toISOString();
                      changeRecord({
                        scheduledDepartureTimeUtc: newStd,
                        scheduledArrivalTimeUtc: sta,
                        changed: true
                      });
                    }}
                  />
                )}
              </div>
            </div>
          )}
          </Grid>
        </Grid>
      </FormDialog>
    )
  }
  return (<></>);
}

export default EditTripLegStdDialog;
